export default "__VITE_ASSET__DofGh$sn__"